import LegalDocumentLayout, { LegalSection } from '../components/LegalDocumentLayout'

const EFFECTIVE_DATE = 'February 11, 2026'
const LAST_UPDATED = 'February 11, 2026'

const sections: LegalSection[] = [
  {
    id: 'request-method',
    title: 'How to Request Deletion',
    content: (
      <>
        <p>
          Send an email to{' '}
          <a href="mailto:support@asterode.ai" className="font-semibold text-ink-500 hover:text-ink-700">
            support@asterode.ai
          </a>{' '}
          from the email address linked to your Asterode account.
        </p>
        <p>Using the registered account email helps us verify identity and prevent unauthorized deletion requests.</p>
      </>
    ),
  },
  {
    id: 'template',
    title: 'Email Template',
    content: (
      <>
        <p>You can use this template for a faster request process:</p>
        <pre className="overflow-x-auto rounded-2xl border border-[var(--line-200)] bg-ink-50 p-4 text-xs leading-relaxed text-ink-700 sm:text-sm">
{`Subject: Data Deletion Request - Asterode

Hello Asterode Support,

I request permanent deletion of my Asterode account data.

Account email: [your email]
Reason (optional): [optional note]

Thank you.`}
        </pre>
      </>
    ),
  },
  {
    id: 'scope',
    title: 'What Gets Deleted',
    content: (
      <ul className="list-disc space-y-2 pl-6">
        <li>Account profile and authentication records in Asterode systems.</li>
        <li>Conversation history, prompts, and responses retained by Asterode.</li>
        <li>Uploaded files and associated metadata stored by Asterode.</li>
        <li>Usage-level preferences, project labels, and saved pages.</li>
      </ul>
    ),
  },
  {
    id: 'timeline',
    title: 'Processing Timeline',
    content: (
      <ul className="list-disc space-y-2 pl-6">
        <li>Verification and intake: typically 1 to 5 business days.</li>
        <li>Deletion workflow starts once verification is complete.</li>
        <li>Permanent removal from active systems follows retention windows used for security and integrity checks.</li>
      </ul>
    ),
  },
  {
    id: 'important-notes',
    title: 'Important Notes',
    content: (
      <>
        <ul className="list-disc space-y-2 pl-6">
          <li>Deletion is permanent and cannot be reversed.</li>
          <li>You may need to create a new account to use Asterode again.</li>
          <li>Third-party AI providers may retain data under their own policies once requests were processed by them.</li>
        </ul>
        <p>
          If you only want to remove selected conversations, use in-app deletion controls instead of full account deletion.
        </p>
      </>
    ),
  },
  {
    id: 'contact',
    title: 'Contact',
    content: (
      <>
        <p>
          For deletion requests and related support:
          <br />
          <a href="mailto:support@asterode.ai" className="font-semibold text-ink-500 hover:text-ink-700">
            support@asterode.ai
          </a>
        </p>
      </>
    ),
  },
]

const Delete = () => {
  return (
    <LegalDocumentLayout
      title="Delete Your Asterode Data"
      subtitle="Use this page to request full account data deletion. We designed the process to be clear, verifiable, and user-controlled."
      effectiveDate={EFFECTIVE_DATE}
      lastUpdated={LAST_UPDATED}
      introCallout={
        <p>
          If your goal is only to clean old chats, in-app conversation deletion is usually faster than full account removal.
        </p>
      }
      sections={sections}
    />
  )
}

export default Delete


